var __rspack_ns_object = {"rE":"1.180.0"}